module.exports = __webpack_public_path__ + "static/media/time.92496774.svg";